import * as React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

import { cn } from '@common/lib/utils';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        `tw-z-[9999] tw-w-64 tw-rounded-md tw-border tw-bg-popover tw-p-4 tw-text-popover-foreground tw-shadow-md
        tw-outline-none tw-data-[state=open]:tw-animate-in tw-data-[state=closed]:tw-animate-out
        tw-data-[state=closed]:tw-fade-out-0 tw-data-[state=open]:tw-fade-in-0 tw-data-[state=closed]:tw-zoom-out-95
        tw-data-[state=open]:tw-zoom-in-95 tw-data-[side=bottom]:tw-slide-in-from-top-2
        tw-data-[side=left]:tw-slide-in-from-right-2 tw-data-[side=right]:tw-slide-in-from-left-2
        tw-data-[side=top]:tw-slide-in-from-bottom-2 tw-origin-[var(--radix-hover-card-content-transform-origin)]`,
        className
      )}
      {...props}
    />
  </HoverCardPrimitive.Portal>
));
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
